import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// React
import React, { useContext, useEffect, useState, useImperativeHandle } from 'react';

// MUI
import { Box, Grid, ListItem, IconButton, ListItemText, Tooltip, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

// lib
import i18n from '../i18n';

// Device breakpoints
import DeviceBreakPoints from '../configurations/deviceBreakpoints';
import { roles } from '../configurations/settings';

//api
import { uploadDocument } from '../api/uploadDocument';
import { deleteDocument } from '../api/deleteDocument';
import { downloadDocument } from '../api/downloadDocument';
import { retrieveUserCompanyDetails } from '../api/retrieveUserCompanyDetails';
import { retrieveUserCompanyStatus } from '../api/retrieveUserCompanyStatus';
import { submitCompanyForStatusUpdateV1 } from '../api/submitCompanyForStatusUpdateV1';
import { submitCompanyForStatusUpdateV2 } from '../api/submitCompanyForStatusUpdateV2';
import { createDCSCompany } from '../api/createDCSCompany';

//components
import ConsentAcceptanceSection from './consentAcceptanceSection';
import DropZoneComponent from './dropZoneComponent';
import AccordionComponent from './accordionComponent';

// interface

// context
import { CompanyDetailsContext } from '../context/companyContext';
import { ConsentDetailsContextV2 } from '../context/consentContextV2';
import { UserDetailsContext } from '../context/userContext';

// utils
import { bytesToSize, cloneObject, generatePayloadObject, getCountrySpecificDocuments, isEmpty } from '../utils/util';

//axios

var RegisterDocumentDetails = function RegisterDocumentDetails(props, ref) {
  var _props$consentSection;
  var _DeviceBreakPoints = DeviceBreakPoints(),
    isSmallDevice = _DeviceBreakPoints.isSmallDevice;
  var _useState = useState(getCountrySpecificDocuments(cloneObject(props === null || props === void 0 ? void 0 : props.displayFields), props === null || props === void 0 ? void 0 : props.countryCode)),
    _useState2 = _slicedToArray(_useState, 2),
    displaySections = _useState2[0],
    setDisplaySections = _useState2[1];
  var _useContext = useContext(CompanyDetailsContext),
    companyData = _useContext.companyData,
    setCompanyDetailsFromInput = _useContext.setCompanyDetailsFromInput;
  var _useContext2 = useContext(UserDetailsContext),
    userData = _useContext2.userData;
  var _useContext3 = useContext(ConsentDetailsContextV2),
    consentDataV2 = _useContext3.consentDataV2;
  var _useState3 = useState([{
      accepted: false,
      documentName: '',
      documentTypeId: '',
      documentUrl: '',
      displayName: ''
    }]),
    _useState4 = _slicedToArray(_useState3, 2),
    consentCheck = _useState4[0],
    setConsentCheck = _useState4[1];
  var genericPayload = generatePayloadObject(props === null || props === void 0 ? void 0 : props.axiosInstance, props === null || props === void 0 ? void 0 : props.clientToken, props === null || props === void 0 ? void 0 : props.tenantId, props === null || props === void 0 ? void 0 : props.role, props === null || props === void 0 ? void 0 : props.requestorPayload, props === null || props === void 0 ? void 0 : props.dcsJwtToken);
  // this is needed to open tooltip in responsive mode
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    openTooltip = _useState6[0],
    setOpenTooltip = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    docName = _useState8[0],
    setDocName = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    dynamicDocSet = _useState10[0],
    setDynamicDocSet = _useState10[1];
  var tempDisplayFields = [];
  useEffect(function () {
    var displayFieldsLocal = getCountrySpecificDocuments(cloneObject(props === null || props === void 0 ? void 0 : props.displayFields), props === null || props === void 0 ? void 0 : props.countryCode);
    setDynamicDocSet(true);
    if (companyData !== null && companyData !== void 0 && companyData.documents) {
      var _companyData$document;
      (_companyData$document = companyData.documents) === null || _companyData$document === void 0 || _companyData$document.forEach(function (document) {
        displayFieldsLocal.forEach(function (item) {
          var _item$documents;
          item === null || item === void 0 || (_item$documents = item.documents) === null || _item$documents === void 0 || _item$documents.forEach(function (documentForm) {
            if (documentForm.documentId === document.docTypeId) {
              documentForm.uploadedDocumentsList = [document];
            }
          });
        });
        setDisplaySections(displayFieldsLocal);
        tempDisplayFields = _toConsumableArray(displayFieldsLocal);
        !isEmpty(props === null || props === void 0 ? void 0 : props.dynamicForm) && (props === null || props === void 0 ? void 0 : props.booleanFunc) && (props === null || props === void 0 ? void 0 : props.booleanFunc(consentCheck && (consentCheck === null || consentCheck === void 0 ? void 0 : consentCheck.some(function (item) {
          return item.documentTypeId;
        })) && (consentCheck === null || consentCheck === void 0 ? void 0 : consentCheck.some(function (item) {
          return !item.accepted;
        })) || (companyData !== null && companyData !== void 0 && companyData.dcsCompanyId ? true : false) || (displayFieldsLocal === null || displayFieldsLocal === void 0 ? void 0 : displayFieldsLocal.some(function (item) {
          var _item$documents2;
          return (_item$documents2 = item.documents) === null || _item$documents2 === void 0 ? void 0 : _item$documents2.some(function (document) {
            var _document$uploadedDoc;
            return !document.uploadedDocumentsList || document.mandatory && ((_document$uploadedDoc = document.uploadedDocumentsList) === null || _document$uploadedDoc === void 0 ? void 0 : _document$uploadedDoc.length) === 0;
          });
        }))));
      });
    }
  }, [props === null || props === void 0 ? void 0 : props.displayFields]);
  useEffect(function () {
    setDynamicDocSet(false);
  }, [dynamicDocSet]);
  var getDocumentsList = function getDocumentsList(displaySections, docTypeId) {
    var docList = [];
    if (companyData.documents) {
      companyData.documents.filter(function (item) {
        return item.docTypeId !== docTypeId;
      }).forEach(function (doc) {
        docList.push(doc);
      });
    }
    displaySections.forEach(function (item) {
      if (item.documents) {
        item.documents.forEach(function (documentForm) {
          var _documentForm$uploade;
          (_documentForm$uploade = documentForm.uploadedDocumentsList) === null || _documentForm$uploade === void 0 || _documentForm$uploade.forEach(function (document) {
            docList.push(document);
          });
        });
      }
    });
    return docList;
  };
  useEffect(function () {
    (props === null || props === void 0 ? void 0 : props.booleanFunc) && (props === null || props === void 0 ? void 0 : props.booleanFunc(consentCheck && (consentCheck === null || consentCheck === void 0 ? void 0 : consentCheck.some(function (item) {
      return item.documentTypeId;
    })) && (consentCheck === null || consentCheck === void 0 ? void 0 : consentCheck.some(function (item) {
      return !item.accepted;
    })) || (companyData !== null && companyData !== void 0 && companyData.dcsCompanyId ? true : false) || (displaySections === null || displaySections === void 0 ? void 0 : displaySections.some(function (item) {
      var _item$documents3;
      return (_item$documents3 = item.documents) === null || _item$documents3 === void 0 ? void 0 : _item$documents3.some(function (document) {
        var _document$uploadedDoc2;
        return !document.uploadedDocumentsList || document.mandatory && ((_document$uploadedDoc2 = document.uploadedDocumentsList) === null || _document$uploadedDoc2 === void 0 ? void 0 : _document$uploadedDoc2.length) === 0;
      });
    }))));
  }, [consentCheck, displaySections]);
  var updateBasedOnDocType = function updateBasedOnDocType(updateType, documentForm, document) {
    var _documentForm$uploade2, _documentForm$uploade3, _documentForm$uploade4;
    switch (updateType) {
      case 'add':
        !documentForm.uploadedDocumentsList && (documentForm.uploadedDocumentsList = []);
        (_documentForm$uploade2 = documentForm.uploadedDocumentsList) === null || _documentForm$uploade2 === void 0 || _documentForm$uploade2.push(document);
        break;
      case 'delete':
        var docIndex = (_documentForm$uploade3 = documentForm.uploadedDocumentsList) === null || _documentForm$uploade3 === void 0 ? void 0 : _documentForm$uploade3.findIndex(function (displayDoc) {
          return displayDoc.docTypeId === document.docTypeId;
        });
        docIndex !== -1 && ((_documentForm$uploade4 = documentForm.uploadedDocumentsList) === null || _documentForm$uploade4 === void 0 ? void 0 : _documentForm$uploade4.splice(Number(docIndex), 1));
        break;
      default:
        break;
    }
  };
  var updateDocFields = function updateDocFields(displayFieldsLocal, document, updateType, companyResponse) {
    displayFieldsLocal.forEach(function (item) {
      var _item$documents4;
      item === null || item === void 0 || (_item$documents4 = item.documents) === null || _item$documents4 === void 0 || _item$documents4.forEach(function (documentForm) {
        if (documentForm.documentId === document.docTypeId) {
          updateBasedOnDocType(updateType, documentForm, document);
        } else {
          if (!isEmpty(companyResponse)) {
            var _companyResponse$docu;
            companyResponse === null || companyResponse === void 0 || (_companyResponse$docu = companyResponse.documents) === null || _companyResponse$docu === void 0 || _companyResponse$docu.forEach(function (doc) {
              if (documentForm.documentId === doc.docTypeId) {
                documentForm.uploadedDocumentsList = [doc];
              }
            });
          }
        }
      });
    });
  };
  var updateDocumentsList = function updateDocumentsList(document, updateType, file, companyResponse) {
    var _tempDisplayFields;
    var displayFieldsLocal = ((_tempDisplayFields = tempDisplayFields) === null || _tempDisplayFields === void 0 ? void 0 : _tempDisplayFields.length) > 0 ? _toConsumableArray(tempDisplayFields) : _toConsumableArray(displaySections);
    if (!isEmpty(file)) {
      document.file = file;
    }
    updateDocFields(displayFieldsLocal, document, updateType, companyResponse);
    if (!isEmpty(props === null || props === void 0 ? void 0 : props.dynamicForm)) {
      setCompanyDetailsFromInput(_objectSpread(_objectSpread({}, companyData), {}, {
        documents: getDocumentsList(displayFieldsLocal, updateType === 'add' ? null : document.docTypeId)
      }));
    }
    setDisplaySections(displayFieldsLocal);
    tempDisplayFields = _toConsumableArray(displayFieldsLocal);
  };
  var setValidationErrorMessage = function setValidationErrorMessage(message) {
    props.errorHandler({
      message: message
    });
  };
  var deleteDocImpl = function deleteDocImpl(document, docTypeId) {
    if (companyData.companyId && document.docLink) deleteDocument(companyData.companyId, document.docLink, docTypeId, genericPayload).then(function (response) {
      props === null || props === void 0 || props.setLoader(false);
      if (response.data === i18n.t('REGISTRATION.DOCUMENT_DELETE_SUCCESSFUL')) {
        retrieveUserCompanyDetails(String(companyData === null || companyData === void 0 ? void 0 : companyData.companyId), genericPayload).then(function (companyDataResponse) {
          if (companyDataResponse.data) {
            setCompanyDetailsFromInput(companyDataResponse.data);
            props === null || props === void 0 || props.setSnackbar(true);
            props === null || props === void 0 || props.setSnackBarMessage(response.data);
            props === null || props === void 0 || props.setSnackBarSeverity('success');
            updateDocumentsList(document, 'delete', null, companyDataResponse.data);
          }
        });
      } else {
        props.errorHandler({
          message: i18n.t('ERROR')
        });
      }
    })["catch"](function (error) {
      handleErrorResponse(error);
    });
  };
  var handleDelete = function handleDelete(name, docTypeId) {
    var _companyData$document2;
    var customerDocMetaId;
    props === null || props === void 0 || props.setSnackbar(false);
    if ((companyData !== null && companyData !== void 0 && companyData.companyId || !isEmpty(props === null || props === void 0 ? void 0 : props.dynamicForm)) && (companyData === null || companyData === void 0 || (_companyData$document2 = companyData.documents) === null || _companyData$document2 === void 0 ? void 0 : _companyData$document2.length) > 0) {
      companyData === null || companyData === void 0 || companyData.documents.forEach(function (document) {
        if (isEmpty(props === null || props === void 0 ? void 0 : props.dynamicForm)) {
          if (document.docTypeId === docTypeId && name === document.documentName && !customerDocMetaId && companyData !== null && companyData !== void 0 && companyData.companyId && document.docLink) {
            customerDocMetaId = document.docLink;
            props === null || props === void 0 || props.setLoader(true);
            deleteDocImpl(document, docTypeId);
          }
        } else {
          props === null || props === void 0 || props.setLoader(false);
          document.docTypeId === docTypeId && updateDocumentsList(document, 'delete', null, null);
        }
      });
    }
  };
  var handleErrorResponse = function handleErrorResponse(responseError) {
    props === null || props === void 0 || props.setLoader(false);
    if (responseError.response) {
      var _responseError$respon;
      setValidationErrorMessage((_responseError$respon = responseError.response.data) === null || _responseError$respon === void 0 ? void 0 : _responseError$respon.message);
    }
  };
  var viewDocument = function viewDocument(name, docId) {
    var documentTypeId = docId;
    var customerDocMetaId = '';
    if ((companyData === null || companyData === void 0 ? void 0 : companyData.documents.length) > 0) {
      companyData === null || companyData === void 0 || companyData.documents.forEach(function (document) {
        if (document.docTypeId === documentTypeId && name === document.documentName && customerDocMetaId === '') {
          customerDocMetaId = document.docLink;
          props === null || props === void 0 || props.setLoader(true);
          downloadDocument(customerDocMetaId, docId, genericPayload).then(function (response) {
            props === null || props === void 0 || props.setLoader(false);
            var apiResponse = response.hasOwnProperty('request') ? response.request.response : {};
            var fileName = name;
            var blob = new Blob([apiResponse], {
              type: 'application/octet-stream'
            });
            var url = window.URL.createObjectURL(blob);
            var link = window.document.createElement('a');
            window.document.body.appendChild(link);
            link.href = url;
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(url);
          })["catch"](function (error) {
            handleErrorResponse(error);
          });
        }
      });
    }
  };
  var renderDocHTML = function renderDocHTML(item) {
    return /*#__PURE__*/React.createElement(Box, {
      sx: {
        display: 'flex',
        flexWrap: 'wrap'
      }
    }, /*#__PURE__*/React.createElement(ListItem, {
      sx: isSmallDevice ? {
        padding: '0 !important',
        textOverflow: 'ellipsis',
        wordBreak: 'break-all',
        maxWidth: '7rem'
      } : {
        padding: '0 !important',
        width: '325px !important'
      }
    }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(DescriptionOutlinedIcon, {
      fontSize: "small"
    })), /*#__PURE__*/React.createElement(Tooltip, {
      open: item.documentName === docName && openTooltip,
      onOpen: function onOpen() {
        setOpenTooltip(true);
        setDocName(item.documentName);
      },
      onClose: function onClose() {
        setOpenTooltip(false);
      },
      title: item.documentName,
      placement: "bottom-start",
      enterTouchDelay: 0
    }, /*#__PURE__*/React.createElement(ListItemText, {
      primaryTypographyProps: {
        fontSize: '0.8rem !important',
        width: 'auto',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      },
      secondaryTypographyProps: {
        fontSize: '0.8rem !important'
      },
      primary: item.documentName,
      secondary: bytesToSize(item.documentSize, 2),
      onMouseOver: function onMouseOver() {
        setOpenTooltip(true);
        setDocName(item.documentName);
      }
      //onclick for responsive mode
      ,
      onClick: function onClick() {
        setOpenTooltip(true);
        setDocName(item.documentName);
      }
    }))), !companyData.dcsCompanyId && /*#__PURE__*/React.createElement(Box, {
      sx: {
        wordWrap: 'anywhere'
      }
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: i18n.t('TOOLTIP_DELETE'),
      "aria-label": "delete"
    }, /*#__PURE__*/React.createElement(IconButton, {
      onClick: function onClick() {
        if (item.documentName && item.docTypeId) handleDelete(item.documentName, item.docTypeId);
      }
    }, /*#__PURE__*/React.createElement(DeleteIcon, {
      fontSize: "medium"
    })))), isEmpty(props === null || props === void 0 ? void 0 : props.dynamicForm) && /*#__PURE__*/React.createElement(Box, {
      sx: {
        wordWrap: 'anywhere'
      }
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: i18n.t('TOOLTIP_VIEW'),
      "aria-label": "view"
    }, /*#__PURE__*/React.createElement(IconButton, {
      onClick: function onClick() {
        if (item.documentName && item.docTypeId) viewDocument(item.documentName, item.docTypeId);
      }
    }, /*#__PURE__*/React.createElement(VisibilityOutlinedIcon, {
      fontSize: "medium"
    })))));
  };
  var getCompanyDetailsImpl = function getCompanyDetailsImpl(fileArr, docTypeId, file, uploadedDocResponse) {
    if (companyData.companyId) retrieveUserCompanyDetails(companyData.companyId, genericPayload).then(function (companyDataResponse) {
      if (companyDataResponse.data) {
        setCompanyDetailsFromInput(companyDataResponse.data);
        fileArr.docTypeId = docTypeId;
        updateDocumentsList(fileArr, 'add', file, companyDataResponse.data);
        props === null || props === void 0 || props.setSnackbar(true);
        props === null || props === void 0 || props.setLoader(false);
        props === null || props === void 0 || props.setSnackBarSeverity('success');
        props === null || props === void 0 || props.setSnackBarMessage(uploadedDocResponse.data);
      }
    });
  };
  var uploadDocumentImpl = function uploadDocumentImpl(documentType, file, docTypeId, fileArr) {
    uploadDocument(documentType, file, String(companyData.companyId), docTypeId, genericPayload).then(function (uploadedDocResponse) {
      if (uploadedDocResponse && uploadedDocResponse.data === i18n.t('REGISTRATION.DOCUMENT_UPLOAD_SUCCESSFUL')) {
        if (companyData !== null && companyData !== void 0 && companyData.companyId) getCompanyDetailsImpl(fileArr, docTypeId, file, uploadedDocResponse);
      } else {
        props === null || props === void 0 || props.setLoader(false);
        if (uploadedDocResponse) {
          setValidationErrorMessage(uploadedDocResponse.data);
        }
      }
    })["catch"](function (error) {
      props === null || props === void 0 || props.setLoader(false);
      if (error.response) {
        var _error$response$data;
        setValidationErrorMessage((_error$response$data = error.response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message);
      }
    });
  };
  var handleFileUpload = function handleFileUpload(fileArr, file, docTypeId, documentType) {
    props === null || props === void 0 || props.setSnackbar(false);
    props === null || props === void 0 || props.setLoader(true);
    if (!isEmpty(props === null || props === void 0 ? void 0 : props.dynamicForm)) {
      fileArr.docTypeId = docTypeId;
      updateDocumentsList(fileArr, 'add', file, null);
      props === null || props === void 0 || props.setLoader(false);
    } else if (companyData !== null && companyData !== void 0 && companyData.companyId) {
      uploadDocumentImpl(documentType, file, docTypeId, fileArr);
    }
  };
  var createDCSCompanyImpl = function createDCSCompanyImpl(companyDetailsPayload) {
    createDCSCompany(companyDetailsPayload, genericPayload).then(function (response) {
      props === null || props === void 0 || props.setLoader(false);
      if (response.data) {
        retrieveUserCompanyStatus(genericPayload).then(function (userResponse) {
          if (userResponse.data) {
            var _userResponse$data, _response$data, _response$data2, _response$data3;
            props === null || props === void 0 || props.successHandler({
              companyRegStatusDescription: userResponse === null || userResponse === void 0 || (_userResponse$data = userResponse.data) === null || _userResponse$data === void 0 ? void 0 : _userResponse$data.companyRegStatusDescription,
              companyId: response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.companyId,
              status: response === null || response === void 0 || (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.status,
              userId: response === null || response === void 0 || (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.userId
            });
            props === null || props === void 0 || props.handleActiveTab(4);
          }
        });
      } else {
        setValidationErrorMessage(i18n.t('REGISTRATION.COMPANY_ERROR'));
      }
    })["catch"](function (error) {
      props === null || props === void 0 || props.setLoader(false);
      if (error.response) {
        var _error$response;
        setValidationErrorMessage((_error$response = error.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 ? void 0 : _error$response.message);
      } else {
        setValidationErrorMessage(i18n.t('REGISTRATION.COMPANY_ERROR'));
      }
    });
  };
  useImperativeHandle(ref, function () {
    return {
      handleCreateCompany: function handleCreateCompany(companyDetailsPayload) {
        if (isEmpty(props === null || props === void 0 ? void 0 : props.dynamicForm)) {
          createDCSCompanyImpl(companyDetailsPayload);
        } else {
          var companyDataObject = {
            'userData': Object.fromEntries(Object.entries(userData === null || userData === void 0 ? void 0 : userData.user).filter(
            // ignoring the below rule so that code can be reused for custom onboarding also
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2),
                _ = _ref2[0],
                value = _ref2[1];
              return !isEmpty(value);
            })),
            'companyInfo': Object.fromEntries(Object.entries(companyData).filter(
            // ignoring the below rule so that code can be reused for custom onboarding also
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            function (_ref3) {
              var _ref4 = _slicedToArray(_ref3, 2),
                _ = _ref4[0],
                value = _ref4[1];
              return _typeof(value) !== 'object' && value && value !== '';
            }))
          };
          // for custom onboarding form
          props === null || props === void 0 || props.successHandler({
            companyRegStatusDescription: 'Submitted successfully',
            companyId: '',
            status: '',
            userId: '',
            companyData: companyDataObject
          });
          props === null || props === void 0 || props.setOpenRegisterModal(false);
        }
      },
      handleSubmitForApproval: function handleSubmitForApproval() {
        var _this = this;
        var documentTypeIds = [];
        consentDataV2 === null || consentDataV2 === void 0 || consentDataV2.forEach(function (consentItem) {
          documentTypeIds.push(consentItem.marketplaceAgrmntInfoId);
        });
        props === null || props === void 0 || props.setLoader(true);
        submitCompanyForStatusUpdateV1(genericPayload).then(function (statusResponseV1) {
          if ((props === null || props === void 0 ? void 0 : props.role) === roles.SELLER_ROLE) {
            submitCompanyForStatusUpdateV2(genericPayload, documentTypeIds).then(function (statusResponseV2) {
              _this.handleCreateCompany(statusResponseV2 === null || statusResponseV2 === void 0 ? void 0 : statusResponseV2.data);
            })["catch"](function () {
              props === null || props === void 0 || props.setLoader(false);
            });
          } else {
            _this.handleCreateCompany(statusResponseV1 === null || statusResponseV1 === void 0 ? void 0 : statusResponseV1.data);
          }
        })["catch"](function () {
          props === null || props === void 0 || props.setLoader(false);
        });
      }
    };
  });
  var headingSection = function headingSection(heading, desc) {
    return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Typography, {
      sx: {
        fontWeight: 'bold'
      },
      variant: "h6",
      component: "h6"
    }, i18n.t(heading)), /*#__PURE__*/React.createElement(Typography, {
      component: "p",
      sx: {
        fontSize: '0.8rem'
      },
      color: "secondary.dark"
    }, i18n.t(desc ? desc : '')));
  };
  var contentSection = function contentSection(sections) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, sections === null || sections === void 0 ? void 0 : sections.map(function (document) {
      var _document$uploadedDoc3, _document$uploadedDoc4, _document$uploadedDoc5;
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: document.documentId
      }, document.isVisible && /*#__PURE__*/React.createElement(Box, {
        my: 3
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 3,
        lg: 3,
        xl: 3
      }, /*#__PURE__*/React.createElement(Box, {
        component: 'span'
      }, i18n.t(document.documentName), " ", document.mandatory && /*#__PURE__*/React.createElement(Box, {
        component: 'span'
      }, "*")), /*#__PURE__*/React.createElement(Typography, {
        component: "p",
        sx: {
          fontSize: '0.8rem'
        },
        color: "secondary.dark"
      }, i18n.t(document.description ? document.description : ''))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 3.5,
        lg: 3.5,
        xl: 3.5
      }, /*#__PURE__*/React.createElement(DropZoneComponent, {
        fileUpload: function fileUpload(fileArr, file) {
          return handleFileUpload(fileArr, file, document.documentId, document.type);
        },
        type: document.type,
        dcsCompanyId: companyData.dcsCompanyId,
        allowedFormats: document.allowedFormats,
        maxFileSize: document.maxFileSize,
        validationError: function validationError(msg) {
          return setValidationErrorMessage(msg);
        },
        environment: props === null || props === void 0 ? void 0 : props.environment,
        uploadedDocs: document.uploadedDocumentsList
      }))), /*#__PURE__*/React.createElement(Box, null, ((_document$uploadedDoc3 = document.uploadedDocumentsList) === null || _document$uploadedDoc3 === void 0 || (_document$uploadedDoc3 = _document$uploadedDoc3.filter(function (uploadedDocument) {
        return uploadedDocument.docTypeId === document.documentId;
      })[0]) === null || _document$uploadedDoc3 === void 0 ? void 0 : _document$uploadedDoc3.docTypeId) && /*#__PURE__*/React.createElement(React.Fragment, {
        key: (_document$uploadedDoc4 = document.uploadedDocumentsList) === null || _document$uploadedDoc4 === void 0 || (_document$uploadedDoc4 = _document$uploadedDoc4.filter(function (uploadedDocument) {
          return uploadedDocument.docTypeId === document.documentId;
        })[0]) === null || _document$uploadedDoc4 === void 0 ? void 0 : _document$uploadedDoc4.docTypeId
      }, renderDocHTML((_document$uploadedDoc5 = document.uploadedDocumentsList) === null || _document$uploadedDoc5 === void 0 ? void 0 : _document$uploadedDoc5.filter(function (uploadedDocument) {
        return uploadedDocument.docTypeId === document.documentId;
      })[0])))));
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    sx: {
      paddingTop: '21px'
    }
  }, displaySections === null || displaySections === void 0 ? void 0 : displaySections.map(function (item, index) {
    var _item$documents5, _item$documents6;
    return /*#__PURE__*/React.createElement(React.Fragment, null, item !== null && item !== void 0 && item.documents && ((_item$documents5 = item.documents) === null || _item$documents5 === void 0 ? void 0 : _item$documents5.length) > 0 && !item.isAccordion ? /*#__PURE__*/React.createElement(React.Fragment, null, headingSection(item.sectionName, item.description), contentSection(item.documents)) : (item === null || item === void 0 ? void 0 : item.documents) && ((_item$documents6 = item.documents) === null || _item$documents6 === void 0 ? void 0 : _item$documents6.length) > 0 && /*#__PURE__*/React.createElement(AccordionComponent, {
      sections: item,
      index: index,
      environment: props === null || props === void 0 ? void 0 : props.environment,
      role: props === null || props === void 0 ? void 0 : props.role,
      headerCallback: headingSection,
      contentCallback: contentSection,
      type: "documentType"
    }));
  }), /*#__PURE__*/React.createElement(ConsentAcceptanceSection, {
    consentSection: props !== null && props !== void 0 && (_props$consentSection = props.consentSection) !== null && _props$consentSection !== void 0 && _props$consentSection.length ? props === null || props === void 0 ? void 0 : props.consentSection : undefined,
    role: props === null || props === void 0 ? void 0 : props.role,
    dynamicForm: props === null || props === void 0 ? void 0 : props.dynamicForm,
    regionCode: props === null || props === void 0 ? void 0 : props.regionCode,
    axiosInstance: props === null || props === void 0 ? void 0 : props.axiosInstance,
    environment: props !== null && props !== void 0 && props.environment ? props === null || props === void 0 ? void 0 : props.environment : 'development',
    countryCode: props === null || props === void 0 ? void 0 : props.countryCode,
    handleActiveTab: props === null || props === void 0 ? void 0 : props.handleActiveTab,
    requestorPayload: props === null || props === void 0 ? void 0 : props.requestorPayload,
    dcsJwtToken: props === null || props === void 0 ? void 0 : props.dcsJwtToken,
    clientToken: props === null || props === void 0 ? void 0 : props.clientToken,
    setLoader: function setLoader(value) {
      return props.setLoader(value);
    },
    setConsentCheck: setConsentCheck
  })));
};
RegisterDocumentDetails.displayName = 'RegisterDocumentDetails';
var RegisterDocumentDetailsWrapper = /*#__PURE__*/React.forwardRef(RegisterDocumentDetails);
export default RegisterDocumentDetailsWrapper;